import {CommonMessages} from '../common.messages';

export const ChangeTradingAccountStatusMessages = {
    UpdateAccountStatusFailed: {
        key: 'UpdateAccountStatusFailed',
        message: 'Unable to update account status.'
    },
    DifferentStatusValidationFailed: {
        key: 'DifferentStatusValidationFailed',
        message: 'Different status must be selected.'
    },
    UpdateAccountStatusSucceeded: {
        key: 'UpdateAccountStatusSucceeded',
        message: 'Account status is successfully updated.'
    },
    NotActiveAccountOwner: {
        key: 'NotActiveAccountOwner',
        message: 'Unable to activate account of inactive owner.'
    },
    ChangeStatusToClosedRestricted: {
        key: 'ChangeStatusToClosedRestricted',
        message: 'Additional permissions are required for client termination.'
    },
    ...CommonMessages
};
